export default __webpack_public_path__ + "8160c97725f65cc76cefda974ab7e075.webp";